export const PROJECT_DESIGN_SYSTEM_MAX_BYTES = 64 * 1024;
export const PROJECT_DESIGN_SYSTEM_VALIDATOR_VERSION = '0.4.0';
export const PROJECT_DESIGN_SYSTEM_UPDATED_EVENT = 'attune:project-design-system-updated';

export type ProjectDesignSystemSource = 'upload' | 'paste' | 'manual' | 'github' | 'ai' | 'restore';

export type ProjectDesignSystemFindingSeverity = 'error' | 'warning' | 'info';

export interface ProjectDesignSystemFinding {
  severity: ProjectDesignSystemFindingSeverity;
  path: string | null;
  message: string;
  rule: string | null;
}

export interface ProjectDesignSystemLintSummary {
  errors: number;
  warnings: number;
  infos: number;
}

export interface ProjectDesignSystemTokenSnapshot {
  name: string | null;
  description: string | null;
  colors: Array<{ name: string; value: string }>;
  typography: Array<{
    name: string;
    fontFamily: string | null;
    fontSize: string | null;
    fontWeight: number | null;
    lineHeight: string | null;
    letterSpacing: string | null;
  }>;
  rounded: Array<{ name: string; value: string }>;
  spacing: Array<{ name: string; value: string }>;
  components: Array<{ name: string; properties: Record<string, string | number | boolean> }>;
  sections: Array<{ heading: string; content: string }>;
}

export interface ProjectDesignSystemVersion {
  id: string;
  projectId: string;
  version: number;
  baseVersion: number | null;
  content: string;
  contentSha256: string;
  specVersion: string | null;
  validatorVersion: string;
  lintSummary: ProjectDesignSystemLintSummary;
  findings: ProjectDesignSystemFinding[];
  tokenSnapshot: ProjectDesignSystemTokenSnapshot;
  source: ProjectDesignSystemSource;
  sourceMetadata: Record<string, unknown>;
  createdByUserId: string;
  createdAt: string;
}

export interface ProjectDesignSystemVersionSummary {
  id: string;
  version: number;
  contentSha256: string;
  specVersion: string | null;
  validatorVersion: string;
  lintSummary: ProjectDesignSystemLintSummary;
  source: ProjectDesignSystemSource;
  createdByUserId: string;
  createdAt: string;
}

export interface ProjectDesignSystemDetail {
  projectId: string;
  workspaceId: string;
  enabled: boolean;
  currentVersion: number | null;
  current: ProjectDesignSystemVersion | null;
  versions: ProjectDesignSystemVersionSummary[];
  updatedAt: string;
}

export interface ProjectDesignSystemContextReference {
  projectId: string;
  version: number;
  revisionId: string;
  contentSha256: string;
  contextVersion: number;
}
